document.addEventListener('DOMContentLoaded', function() {
  // --- Configuration for the Sports Mega Menu ---
  const sportsMegaMenuData = {
    'Running': {
      image: 'https://us.amazfit.com/cdn/shop/files/Running_Hero_Image.png?v=1758874404&width=560',
      title: 'Running',
      products: [
        { name: 'Balance 2', url: '/products/amazfit-balance-2', img: 'https://us.amazfit.com/cdn/shop/files/PP_Image_with_Biocharge.jpg?v=1757510177&width=300', desc: 'Engineered as a premium multi-sport training partner, the Amazfit Balance 2 empowers driven professionals and athletes to push their limits...' },
        { name: 'T-Rex 3 Pro', url: '/products/t-rex-3-pro', img: 'https://us.amazfit.com/cdn/shop/files/20250901-161328.jpg?v=1756714499&width=300', desc: 'Whether you are pushing your limits on a rugged trail, diving beneath the surface, or training for your next big...' },
       { name: 'Active 2 (Round)', url: '/products/active-2-round', img: 'https://us.amazfit.com/cdn/shop/files/1_2_87505969-d5d7-49ce-b866-0a55ca2193c9.jpg?v=1736327982&width=300', desc: 'The Active 2 smartwatch is designed for fashion-conscious, health-focused people who value style and functionality. It features a bright 1.32"...' }
      ]
    },
    'Hiking': {
      image: 'https://us.amazfit.com/cdn/shop/files/20251017-115416.jpg?v=1760727321&width=560',
      title: 'Hiking',
      products: [
        { name: 'T-Rex 3 Pro', url: '/products/t-rex-3-pro', img: 'https://us.amazfit.com/cdn/shop/files/20250901-161328.jpg?v=1756714499&width=300', desc: 'Whether you are pushing your limits on a rugged trail, diving beneath the surface, or training for your next big...' },
        { name: 'T-Rex 3', url: '/products/amazfit-t-rex-3', img: 'https://us.amazfit.com/cdn/shop/files/P1_T-Rex3_GalleryBox_1080x1080_b62d7718-34a8-4ac5-91a4-40f8a4b65a0a.jpg?v=1726188376&width=300', desc: 'T-Rex 3 is a rugged outdoor smartwatch for outdoor and fitness athletes. Engineered to endure with over 3 weeks of...' },
        { name: 'Balance 2', url: '/products/amazfit-balance-2', img: 'https://us.amazfit.com/cdn/shop/files/PP_Image_with_Biocharge.jpg?v=1757510177&width=300', desc: 'Engineered as a premium multi-sport training partner, the Amazfit Balance 2 empowers driven professionals and athletes to push their limits...' }
      ]
    },
    'Triathlon': {
      image: 'https://us.amazfit.com/cdn/shop/files/Triathlete_Hero_Image.png?v=1758874528&width=560',
      title: 'Triathlon',
      products: [
        { name: 'Helio Strap', url: '/products/helio-strap', img: 'https://us.amazfit.com/cdn/shop/files/20250625-145756.jpg?v=1751336918&width=300', desc: 'The Helio Strap is built for those who train hard and recover smarter. Designed for precision, endurance, and everyday versatility,...' },
        { name: 'Balance 2', url: '/products/amazfit-balance-2', img: 'https://us.amazfit.com/cdn/shop/files/PP_Image_with_Biocharge.jpg?v=1757510177&width=300', desc: 'Engineered as a premium multi-sport training partner, the Amazfit Balance 2 empowers driven professionals and athletes to push their limits...' },
        { name: 'T-Rex 3', url: '/products/amazfit-t-rex-3', img: 'https://us.amazfit.com/cdn/shop/files/P1_T-Rex3_GalleryBox_1080x1080_b62d7718-34a8-4ac5-91a4-40f8a4b65a0a.jpg?v=1726188376&width=300', desc: 'T-Rex 3 is a rugged outdoor smartwatch for outdoor and fitness athletes. Engineered to endure with over 3 weeks of...' }
      ]
    },
    'Strength Training': {
      image: 'https://us.amazfit.com/cdn/shop/files/Stregth_Training_Hero_Image.png?v=1758874594&width=560',
      title: 'Strength Training',
      products: [
        { name: 'Balance 2', url: '/products/amazfit-balance-2', img: 'https://us.amazfit.com/cdn/shop/files/PP_Image_with_Biocharge.jpg?v=1757510177&width=300', desc: 'Engineered as a premium multi-sport training partner, the Amazfit Balance 2 empowers driven professionals and athletes to push their limits...' },
        { name: 'T-Rex 3 Pro', url: '/products/t-rex-3-pro', img: 'https://us.amazfit.com/cdn/shop/files/20250901-161328.jpg?v=1756714499&width=300', desc: 'Whether you are pushing your limits on a rugged trail, diving beneath the surface, or training for your next big...' },
        { name: 'Active 2 (Round)', url: '/products/active-2-round', img: 'https://us.amazfit.com/cdn/shop/files/1_2_87505969-d5d7-49ce-b866-0a55ca2193c9.jpg?v=1736327982&width=300', desc: 'The Active 2 smartwatch is designed for fashion-conscious, health-focused people who value style and functionality. It features a bright 1.32"...' }
      ]
    },
    'Fitness & Health': {
      image: 'https://us.amazfit.com/cdn/shop/files/Fitness_Health_Hero_Image.png?v=1758874687&width=560',
      title: 'Fitness & Health',
      products: [
        { name: 'Helio Strap', url: '/products/helio-strap', img: 'https://us.amazfit.com/cdn/shop/files/20250625-145756.jpg?v=1751336918&width=300', desc: 'The Helio Strap is built for those who train hard and recover smarter. Designed for precision, endurance, and everyday versatility,...' },
        { name: 'Bip 6', url: '/products/bip-6', img: 'https://us.amazfit.com/cdn/shop/files/Pamir_45_b21d2a6c-d7bf-4d0f-9cd8-99fdd5de9731.png?v=1742891101&width=300', desc: 'Built to withstand the demands of daily life, the Bip 6 is an everyday smartwatch that seamlessly integrates high-performance fitness...' },
        { name: 'Active 2 (Square)', url: '/products/active-2-square', img: 'https://us.amazfit.com/cdn/shop/files/black.jpg?v=1750064544&width=300', desc: 'Showcasing refined craftsmanship, the Active 2 Square features a sleek square body and polished stainless steel design with sapphire glass...' }
      ]
    },
    'Swimming': {
      image: 'https://us.amazfit.com/cdn/shop/files/Swimming_Hero_Image.png?v=1758874744&width=560',
      title: 'Swimming',
      products: [
        { name: 'Balance 2', url: '/products/amazfit-balance-2', img: 'https://us.amazfit.com/cdn/shop/files/PP_Image_with_Biocharge.jpg?v=1757510177&width=300', desc: 'Engineered as a premium multi-sport training partner, the Amazfit Balance 2 empowers driven professionals and athletes to push their limits...' },
        { name: 'T-Rex 3 Pro', url: '/products/t-rex-3-pro', img: 'https://us.amazfit.com/cdn/shop/files/20250901-161328.jpg?v=1756714499&width=300', desc: 'Whether you are pushing your limits on a rugged trail, diving beneath the surface, or training for your next big...' },
        { name: 'Active 2 (Round)', url: '/products/active-2-round', img: 'https://us.amazfit.com/cdn/shop/files/1_2_87505969-d5d7-49ce-b866-0a55ca2193c9.jpg?v=1736327982&width=300', desc: 'The Active 2 smartwatch is designed for fashion-conscious, health-focused people who value style and functionality. It features a bright 1.32"...' }
      ]
    },
    'Cycling': {
      image: 'https://us.amazfit.com/cdn/shop/files/Cycling_Hero_Image.png?v=1758874797&width=560',
      title: 'Cycling',
      products: [
        { name: 'Balance 2', url: '/products/amazfit-balance-2', img: 'https://us.amazfit.com/cdn/shop/files/PP_Image_with_Biocharge.jpg?v=1757510177&width=300', desc: 'Engineered as a premium multi-sport training partner, the Amazfit Balance 2 empowers driven professionals and athletes to push their limits...' },
        { name: 'T-Rex 3', url: '/products/amazfit-t-rex-3', img: 'https://us.amazfit.com/cdn/shop/files/P1_T-Rex3_GalleryBox_1080x1080_b62d7718-34a8-4ac5-91a4-40f8a4b65a0a.jpg?v=1726188376&width=300', desc: 'T-Rex 3 is a rugged outdoor smartwatch for outdoor and fitness athletes. Engineered to endure with over 3 weeks of...' },
        { name: 'Active 2 (Round)', url: '/products/active-2-round', img: 'https://us.amazfit.com/cdn/shop/files/1_2_87505969-d5d7-49ce-b866-0a55ca2193c9.jpg?v=1736327982&width=300', desc: 'The Active 2 smartwatch is designed for fashion-conscious, health-focused people who value style and functionality. It features a bright 1.32"...' }
      ]
    }
  };

  // Helper function to generate mega menu HTML
  function generateMegaMenuHTML(menuData, sportName, isMobile = false) {
    const dataAttr = sportName.toLowerCase().replace(/\s+/g, '-').replace('&', '');
    return `
      <div class="mega-menu-${isMobile ? 'product-grid' : 'featured'} ${isMobile ? 'mobile' : 'desktop'}-mega-menu-column flex-row" data-mega-menu="sports-${dataAttr}">
        <span class="por icon-prev-state" id="prev-menu">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 11L1 6L6 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </span>
        <div class="col-span-1 left-column">
          <img src="${menuData.image}" alt="${menuData.title}" class="w-full mb-3">
          <h3 class="text-xl font-bold mb-1">${menuData.title}</h3>
          <p class="text-sm text-gray-600"></p>
        </div>
        <div class="col-span-3 right-column">
          ${menuData.products.map(p => `
            <div class="product-card">
              <a href="${p.url}" class="product-image"><img src="${p.img}" alt="${p.name}" loading="lazy"></a>
              <div class="product-info">
                <h4 class="product-title">
                  <a href="${p.url}">
                    ${p.name}
                    <p class="product-description">${p.desc}</p>
                  </a>
                </h4>
              </div>
            </div>
          `).join('')}
        </div>
      </div>`;
  }

  // Helper function to get sport name from text
  function getSportKey(text) {
    return text.trim().replace(/&amp;/g, '&');
  }

  // --- Desktop Menu Logic ---
  function initDesktopMenu() {
    const sportsMenu = document.querySelector('#Details-HeaderMenu-2');
    if (!sportsMenu) return;

    const sportsSubmenuItems = sportsMenu.querySelectorAll('#HeaderMenu-MenuList-2 > li:not(.header__goto-link)');
    let isFirstItem = true;

    sportsSubmenuItems.forEach((item) => {
      const link = item.querySelector('a span');
      if (!link) return;

      const sportName = getSportKey(link.textContent);
      const menuData = sportsMegaMenuData[sportName];

      if (menuData) {
        const megaMenuHTML = generateMegaMenuHTML(menuData, sportName, false);
        item.insertAdjacentHTML('beforeend', megaMenuHTML);
        
        // Show first item by default
        if (isFirstItem) {
          item.classList.add('hover');
          isFirstItem = false;
        } else {
          item.querySelector('.mega-menu-featured').classList.add('hidden');
        }

        // Add hover event listener
        item.addEventListener('mouseenter', function() {
          // Remove hover class from all items
          sportsSubmenuItems.forEach(i => i.classList.remove('hover'));
          
          // Add hover class to current item
          item.classList.add('hover');
          
          // Hide all mega menus
          const allMegaMenus = sportsMenu.querySelectorAll('.mega-menu-featured');
          allMegaMenus.forEach(menu => menu.classList.add('hidden'));
          
          // Show current mega menu
          const currentMegaMenu = item.querySelector('.mega-menu-featured');
          if (currentMegaMenu) {
            currentMegaMenu.classList.remove('hidden');
          }
        });
      }
    });
  }

  // --- Mobile Menu Logic ---
  function initMobileMenu() {
    const mobileMenuContainer = document.querySelector('#Details-menu-drawer-menu-item-2');
    if (!mobileMenuContainer) return;

    const menuDrawerInner = mobileMenuContainer.querySelector('.menu-drawer__inner-submenu');
    const menuList = mobileMenuContainer.querySelector('.menu-drawer__menu');
    const closeButton = mobileMenuContainer.querySelector('.menu-drawer__close-button');
    
    if (!menuList) return;

    const mobileMenuItems = Array.from(menuList.querySelectorAll('li'));
    
    // Skip the first item if it's "Go to Sports"
    const itemsToProcess = mobileMenuItems.filter((item, index) => {
      const link = item.querySelector('a');
      if (!link) return false;
      const linkText = getSportKey(link.textContent);
      return linkText !== 'Go to Sports';
    });

    itemsToProcess.forEach((item) => {
      const link = item.querySelector('a');
      if (!link) return;

      const sportName = getSportKey(link.textContent);
      const menuData = sportsMegaMenuData[sportName];

      if (menuData) {
        // Generate and insert mega menu HTML
        const megaMenuHTML = generateMegaMenuHTML(menuData, sportName, true);
        menuDrawerInner.insertAdjacentHTML('beforeend', megaMenuHTML);
        
        const megaMenu = menuDrawerInner.querySelector(`[data-mega-menu="sports-${sportName.toLowerCase().replace(/\s+/g, '-').replace('&', '')}"]`);
        
        // Initially hide the mega menu
        if (megaMenu) {
          megaMenu.classList.add('hidden');
        }

        // Add click event listener for mobile
        link.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Hide menu list and close button
          if (menuList) menuList.style.display = 'none';
          if (closeButton) closeButton.style.display = 'none';
          
          // Hide all mega menus
          const allMegaMenus = menuDrawerInner.querySelectorAll('.mega-menu-product-grid, .mega-menu-featured');
          allMegaMenus.forEach(menu => menu.classList.add('hidden'));
          
          // Show current mega menu
          if (megaMenu) {
            megaMenu.classList.remove('hidden');
          }
        });

        // Add back button functionality
        if (megaMenu) {
          const backButton = megaMenu.querySelector('#prev-menu');
          if (backButton) {
            backButton.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              // Hide mega menu
              megaMenu.classList.add('hidden');
              
              // Show menu list and close button again
              if (menuList) menuList.style.display = 'block';
              if (closeButton) closeButton.style.display = 'block';
            });
          }
        }
      }
    });
  }

  // Initialize both desktop and mobile menus
  initDesktopMenu();
  initMobileMenu();
  
});

// Hide "Go to Sports" links
document.addEventListener('DOMContentLoaded', function() {
  const allLinks = document.querySelectorAll('a');
  allLinks.forEach(link => {
    if (link.textContent.trim().includes('Go to Sports')) {
      link.style.display = 'none';
      // Also hide parent li if it exists
      const parentLi = link.closest('li');
      if (parentLi) {
        parentLi.style.display = 'none';
      }
    }
  });
});